<h4>What this screen is for</h4>
<p>
    Looking at more than one operator at once. Pick the train operating companies you
    want combined and the screen shows their headline numbers side by side and their
    inventory in a single grid, every row tagged with the operator it came from. It is
    for comparing books across operators, not for working one of them.
</p>
<p>
    <strong>It is a prototype.</strong> Expect the read-only view described here rather
    than the full workbench, and expect it to change.
</p>

<h4>Choosing the operators</h4>
<p>
    <strong>TOCs to combine</strong> at the top lists every operator your account is
    authorised for, and starts with all of them selected. Changing the selection reloads
    both the cards and the grid; clearing it empties the screen. If you change the
    selection while a load is still running, the earlier one is abandoned, so what you
    see always matches what is selected.
</p>

<h4>Reading the numbers</h4>
<ul>
    <li>
        <strong>One card per operator</strong> &mdash; records, new, needing approval, and
        those on auto pilot. They are deliberately left side by side rather than added
        together, because a total across operators is not a number anyone manages to.
    </li>
    <li>
        The grid is the combined inventory: operator, service, journey, departure, class,
        status, OTB bookings and FV allocation, with the operator in the first column.
        Sorting and paging happen in the browser over everything that was loaded, so they
        cover the whole result rather than a page at a time.
    </li>
</ul>

<h4>Worth knowing</h4>
<ul>
    <li>
        <strong>The screen only appears if your account is enabled for it.</strong> Going
        to the address without that takes you to the Dashboard rather than telling you
        why.
    </li>
    <li>
        <strong>The filter sidebar is hidden here.</strong> The operator picker is the
        only control &mdash; there is no filtering by date, service or journey yet, so the
        grid is as large as the combined books.
    </li>
    <li>
        <strong>Nothing on this screen is editable.</strong> There are no overrides, no
        approvals and no re-optimisation; use the single-operator screens for that, which
        also means switching operator in the top bar.
    </li>
    <li>
        If a load fails, the cards and the grid simply go empty rather than showing an
        error. Re-select the operators to try again.
    </li>
</ul>
